import { FunctionaInterfaceAndChildrenResponse, FunctionalInterfaceCreateRequest, FunctionalInterfaceCreateResponse, FunctionalInterfaceResponse, FunctionalInterfacesResponse, FunctionalInterfaceUpdateRequest, NewVersionResponse } from "@/backend/express/controllers/functionalInterfaceController";
import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { VersionResponse } from "@/backend/express/controllers/functionalInterfaceVersionController";

export class FunctionalInterfaceController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async create(functionalInterface: FunctionalInterfaceCreateRequest): Promise<FunctionalInterfaceCreateResponse> {
    return this.client.create(`/api/functional-interfaces`, functionalInterface);
  }

  public async createNewVersion(id: string): Promise<NewVersionResponse> {
    return this.client.create(`/api/functional-interfaces/new-version/${id}`, {});
  }

  public async delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/functional-interfaces/${id}`);
  }

  public async readAll(): Promise<FunctionalInterfacesResponse> {
    return this.client.read(`/api/functional-interfaces`);
  }

  public async readAllLatestVersions(): Promise<FunctionalInterfacesResponse> {
    return this.client.read(`/api/functional-interfaces/latest-versions`);
  }

  public async read(id: string): Promise<FunctionaInterfaceAndChildrenResponse> {
    return this.client.read(`/api/functional-interfaces/${id}`);
  }

  public async update(functionalInterface: FunctionalInterfaceUpdateRequest): Promise<FunctionalInterfaceResponse> {
    return this.client.update(`/api/functional-interfaces`, functionalInterface);
  }

  public async addLatestVersionToProcedure(functionalInterfaceId: string, procedureId: string): Promise<VersionResponse> {
    return this.client.create(`/api/functional-interfaces/add-latest-version-to-procedure`, { functionalInterfaceId, procedureId });
  }
}
